// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F-EU","colBig":"styles_colBig__3xyoe","colSmall":"styles_colSmall__a-8ZY"};